import {SectionItem} from 'common/components/items-menu/types';
import {Placement} from 'common/components/tooltip/types';

export enum DownloadFormat {
  PNG = `PNG`,
  PDF = `PDF`,
  CSV = `CSV`,
}

const DOWNLOAD_PREFIX = `download-`;

export function isScreenshotDownloadFormat(format: DownloadFormat): boolean {
  return [DownloadFormat.PNG, DownloadFormat.PDF].includes(format);
}

function isDownloadFormat(format: string): format is DownloadFormat {
  return (Object.values(DownloadFormat) as string[]).includes(format);
}

export function getDownloadFormatFromAction(action: string): DownloadFormat {
  if (!action.startsWith(DOWNLOAD_PREFIX)) {
    return null;
  }
  const format = action.split(`-`)[1];
  return isDownloadFormat(format) ? format : null;
}

type GetDownloadOptionsParams = {
  downloadFormats?: DownloadFormat[];
  hasCanExportCsvFeatureGate?: boolean;
  hasDownloadCsvDataPermission?: boolean;
  exportCsvDefaultTooltipConfig?: {text: string};
};

export function getDownloadOptions({
  downloadFormats = [DownloadFormat.PNG, DownloadFormat.PDF, DownloadFormat.CSV],
  hasCanExportCsvFeatureGate,
  hasDownloadCsvDataPermission,
  exportCsvDefaultTooltipConfig,
}: GetDownloadOptionsParams = {}): SectionItem[] {
  const hasPermissionMap = {
    [DownloadFormat.PNG]: true,
    [DownloadFormat.PDF]: true,
    [DownloadFormat.CSV]: hasDownloadCsvDataPermission,
  };

  const hasFeatureAccessMap = {
    [DownloadFormat.PNG]: true,
    [DownloadFormat.PDF]: true,
    [DownloadFormat.CSV]: hasCanExportCsvFeatureGate,
  };

  const defaultTooltipConfigMap = {
    [DownloadFormat.PNG]: {},
    [DownloadFormat.PDF]: {},
    [DownloadFormat.CSV]: exportCsvDefaultTooltipConfig
      ? {tooltip: {...exportCsvDefaultTooltipConfig, placement: Placement.Left}}
      : {},
  };

  return [
    {
      label: `Export`,
      icon: `export`,
      subSections: [
        {
          items: downloadFormats
            .filter((format) => hasPermissionMap[format])
            .map((format) => {
              if (hasFeatureAccessMap[format]) {
                return {
                  icon: `export-${format.toLowerCase()}`,
                  label: `Export ${format}`,
                  value: `${DOWNLOAD_PREFIX}${format}`,
                  isDisabled: !hasPermissionMap[format],
                  ...(!hasPermissionMap[format]
                    ? {tooltip: {text: `Contact your project administrator to enable`, placement: Placement.Left}}
                    : defaultTooltipConfigMap[format]),
                };
              } else {
                return {
                  value: `${DOWNLOAD_PREFIX}${format}`,
                  icon: `export-${format.toLowerCase()}`,
                  label: `Export ${format}`,
                  tooltip: {
                    text: `Upgrade your plan to export reports as ${format}.\n[Learn more](https://mixpanel.com/pricing)`,
                    placement: Placement.Left,
                  },
                  isDisabled: true,
                  href: `/pricing/`,
                  target: `_blank`,
                  wrapLabel: true,
                };
              }
            }),
        },
      ],
    },
  ];
}
